var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle7, _circle8, _circle9, _circle10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIlustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 115,
    viewBox: "0 0 150 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1342,
    cy: 61.9909,
    r: 47.0089,
    fill: "#FFE7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0717,
    cy: 30.2501,
    r: 2.94643,
    fill: "#FFE7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.4733,
    cy: 9.49107,
    r: 5.49107,
    fill: "#FFE7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.4913,
    cy: 99.4913,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.491,
    cy: 87.1695,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.313,
    cy: 93.0627,
    r: 2.54464,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8195 17.2688C77.6642 17.2358 77.6642 17.0142 77.8195 16.9812L80.1674 16.4819C80.224 16.4698 80.2683 16.4257 80.2806 16.3692L80.7861 14.0378C80.8196 13.8833 81.04 13.8833 81.0735 14.0378L81.5791 16.3692C81.5914 16.4257 81.6356 16.4698 81.6922 16.4819L84.0402 16.9812C84.1955 17.0142 84.1955 17.2358 84.0402 17.2688L81.6922 17.7681C81.6356 17.7802 81.5914 17.8243 81.5791 17.8808L81.0735 20.2122C81.04 20.3667 80.8196 20.3667 80.7861 20.2122L80.2806 17.8808C80.2683 17.8243 80.224 17.7802 80.1674 17.7681L77.8195 17.2688Z",
    fill: "#F8AFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 65.238C24.2269 64.9548 24.6311 64.9548 24.6911 65.238L25.5865 69.4682C25.6083 69.5713 25.6886 69.652 25.7915 69.6744L29.978 70.5864C30.2591 70.6477 30.2591 71.0486 29.978 71.1099L25.7915 72.0219C25.6886 72.0443 25.6083 72.1251 25.5865 72.2281L24.6911 76.4583C24.6311 76.7415 24.2269 76.7415 24.167 76.4583L23.2716 72.2282C23.2498 72.1251 23.1695 72.0443 23.0666 72.0219L18.8801 71.1099C18.599 71.0486 18.599 70.6477 18.8801 70.5864L23.0666 69.6744C23.1695 69.652 23.2498 69.5713 23.2716 69.4682L24.167 65.238Z",
    fill: "#F8AFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.146 31.488C117.206 31.2048 117.61 31.2048 117.67 31.488L118.193 33.9558C118.214 34.0589 118.295 34.1396 118.398 34.162L120.847 34.6956C121.128 34.7569 121.128 35.1578 120.847 35.2191L118.398 35.7526C118.295 35.7751 118.214 35.8558 118.193 35.9589L117.67 38.4267C117.61 38.7098 117.206 38.7098 117.146 38.4267L116.624 35.9589C116.602 35.8558 116.522 35.7751 116.419 35.7526L113.969 35.2191C113.688 35.1578 113.688 34.7569 113.969 34.6956L116.419 34.162C116.522 34.1396 116.602 34.0589 116.624 33.9558L117.146 31.488Z",
    fill: "#F8AFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.944 71.0527L128.765 74.9279L132.584 75.7601L128.765 76.5922L127.944 80.4674L127.124 76.5922L123.304 75.7601L127.124 74.9279L127.944 71.0527Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.786 40.6963L38.4377 64.9374L51.9645 102.571L60.1342 106.187L70.3127 108.33L80.6252 107.928L86.652 106.857L92.0092 105.25L100.848 100.696L108.348 94.8034L108.927 94.0549C112.196 89.8297 115.094 85.3303 117.59 80.607L101.786 40.6963Z",
    fill: "#FFE7E7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_14257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6222 68.2791L74.517 85.8602",
    stroke: "#F8AFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2791 72.5171L87.8602 81.6223",
    stroke: "#F8AFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2587 54.2231L36.5623 50.4731L94.6873 28.5088L91.6069 36.1427L93.8837 43.2409L45.8033 61.5891L43.2587 54.2231Z",
    fill: "#FFD3D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6963 102.437V102.437C57.5575 105.434 63.903 107.37 70.4389 108.154L70.6022 108.173L75.2621 108.173C78.7527 108.173 82.2334 107.802 85.6453 107.065L86.8005 106.816C90.4485 106.028 93.9707 104.742 97.2678 102.994V102.994C99.8404 101.629 102.259 99.9927 104.482 98.1118L105.203 97.5013C107.133 95.8689 108.923 94.0789 110.555 92.1497V92.1497C112.841 89.4486 114.804 86.4904 116.405 83.335L117.857 80.4731",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9236 64.3784L51.9643 102.696",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.343 40.6733L117.747 80.921",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5129 50.5839L95.5111 28.0388",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6134 65.0689L101.499 40.4314L92.0813 36.0575C91.8109 35.9319 91.695 35.6097 91.8236 35.3407L95.1035 28.4777",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.051 50.3988L42.8043 54.0195C43.0611 54.1571 43.1607 54.4747 43.0288 54.7343L37.9234 64.7802",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7808 49.9146L40.1322 60.7917",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1248 54.625L45.8033 62.125",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8748 35.875L94.5533 43.6429",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1504 28.603L98.995 39.2",
    stroke: "#F8AFAF",
    strokeWidth: 1.07143
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.0801,
    cy: 61.4551,
    r: 2.8125,
    fill: "#FFD3D2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0624,
    cy: 46.9909,
    r: 2.00893,
    fill: "#FFE7E7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.7588,
    cy: 54.7588,
    r: 2.8125,
    fill: "#FFD3D2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.3837,
    cy: 42.4372,
    r: 2.00893,
    fill: "#FFE7E7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_14257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(64 69.2651) rotate(-17.6206)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIlustration);
export default __webpack_public_path__ + "static/media/cart_ilustration.d65569b69fb1a921ba4ad299380f2ce9.svg";
export { ForwardRef as ReactComponent };